import { render, staticRenderFns } from "./ChordProDropdown.vue?vue&type=template&id=3d74a40f&scoped=true"
import script from "./ChordProDropdown.vue?vue&type=script&lang=ts"
export * from "./ChordProDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d74a40f",
  null
  
)

export default component.exports